import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getToken, fetchMe } from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const [state, setState] = useState(getToken() ? "checking" : "denied");

  useEffect(() => {
    let active = true;
    if (!getToken()) return;
    fetchMe()
      .then(() => active && setState("ok"))
      .catch(() => active && setState("denied"));
    return () => {
      active = false;
    };
  }, []);

  if (state === "checking") {
    return (
      <div
        data-testid="admin-auth-checking"
        className="flex min-h-screen items-center justify-center bg-background text-muted-foreground"
      >
        <span className="overline">Verifying access…</span>
      </div>
    );
  }
  if (state === "denied") return <Navigate to="/admin/login" replace />;
  return children;
}
